<script>
export default {
  name: "IconWhiteDocumentNoBorder"
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 19" width="14" height="19">
    <path
      fill-rule="evenodd"
      fill="currentColor"
      d="M10.75 1.1H1.23a.7.7 0 0 0-.71.7v15.4a.7.7 0 0 0 .71.7h11.54a.7.7 0 0 0 .71-.7V3.82Zm1.32 15.4H1.93v-14h8.39v1a.7.7 0 0 0 .7.7h1.05Z"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width=".7"
      d="M5.28 6.88h4.9M5.28 9.68h4.9M5.28 12.48h4.9"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.05"
      d="M3.53 6.88h.35M3.53 9.68h.35M3.53 12.48h.35"
    />
  </svg>
</template>
